module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av130-328648aea6ff20c9e2bb49280c351f94.jpg";